import { globalLoggerToken } from "@/tokens";
import { container, singleton } from "tsyringe";

import { ModuleInterface } from "@interfaces/ModuleInterface";

import ShopifyAnalyticsManager from "./ShopifyAnalyticsManager";

@singleton()
class ShopifyAnalyticsModule
    implements
        ModuleInterface<{
            shopifyAnalyticsManager: ShopifyAnalyticsManager | null;
        }>
{
    exports: {
        shopifyAnalyticsManager: ShopifyAnalyticsManager | null;
    };

    constructor() {
        const logger = container.resolve(globalLoggerToken);

        const createShopifyAnalyticsManagerInstance = () => {
            if (!Shopify) {
                logger.info(
                    "The Shopify object is not available in custom storefronts."
                );
                return null;
            }

            if (!__APP_ID__) {
                logger.warn("App ID is not provided");
                return null;
            }

            return new ShopifyAnalyticsManager(Shopify, __APP_ID__);
        };

        this.exports = {
            shopifyAnalyticsManager: createShopifyAnalyticsManagerInstance(),
        };
    }

    public registerProviders() {
        return {};
    }
}

export default ShopifyAnalyticsModule;
